import { CanDeactivateFn } from '@angular/router';


export const formNavigationGuard: CanDeactivateFn<unknown> = (component: any) => {
        if (component.registrationFormComponent.formGroup.dirty) {
        return confirm('Do you want to navigate out of the current workflow?  Any unsaved changes will be lost');
    }
};
